import { useGetAssignmentsQuery } from "../assignmentsSlice";
import { useParams } from "react-router-dom";

const useAssignmentsPage = () => {
  const { taskId } = useParams();
  const assignments = useGetAssignmentsQuery();
  const dialogsArray = assignments?.data || [];
  const reversedArray = [...dialogsArray]
    ?.filter((item) => {
      if (taskId && taskId !== item?.id) {
        return false;
      }
      return item.topic !== "AUTO" && item.topic !== "Solve the next problem";
    })
    .reverse();

  return {
    assignments: reversedArray,
    assignmentsLoading: assignments?.isLoading,
  };
};

export default useAssignmentsPage;
